/**
 * Created by Florin David on 30/06/2020.
 */

import Action, { ADD_CHAT_ENTRY, SET_SESSION_ID } from 'constants/action-types'

/**
 * Chat History
 */
export default (state = [], action: Action): ChatEntry[] => {
  switch (action.type) {
    case SET_SESSION_ID:
      return action.payload ? state : []
    case ADD_CHAT_ENTRY:
      return [action.payload, ...state]
    default:
      return state
  }
}
